export const DASHBOARD_ROUTE = '/dashboard/';
export const LANDING_ROUTE = '/';
export const ADS_LANDING_ROUTE = '/ads/use-case';
export const HOME_ROUTE = '/home';
export const ONBOARDING_ROUTE = '/verification';
export const PROGRAMS_ROUTE = '/programs';
export const PROGRAM_DETAILS_ROUTE = '/programs/:programId';
export const EMPLOYEES_ROUTE = '/employees';
export const EMPLOYEE_DETAILS_ROUTE = '/employees/employee-details/:emailHash';
export const UPLOAD_EMPLOYEES = '/upload-employees';
export const UPLOAD_EMPLOYEES_STATUS = '/upload-status/:id';
export const CREATE_GROUPS = '/create-groups';
export const CREATE_PROGRAM = '/create-program';
export const EDIT_GROUPS = '/edit-group/:id';
export const GROUPS_ROUTE = '/groups';
export const GROUP_DETAILS_ROUTE = '/employees/group-details/:groupId';
export const REPORTS_ROUTE = '/reports';
export const GIFTING_ROUTE = '/gifting';
export const GIFTING_PLAN_INFO = '/gifting/info/:programId';
export const SUPPORT = '/support';
export const PAYMENTS_ROUTE = '/payments';
export const CHECKOUT_ONLINE_PAY_ROUTE = '/payments/checkout';
export const EVENT_DETAILS = '/home/event-details/:programId/:eventId';
export const PAYMENT_EVENT_DETAILS =
  '/payments/event-details/:programId/:eventId';
export const HOME_EMPLOYEE_DETAILS_ROUTE = '/home/employee-details/:emailHash';
export const INVOICE_DETAILS_ROUTE =
  '/payments/invoice/details/:startDate/:endDate';
export const PAY_INVOICE_ROUTE = '/payments/pay-invoice/:startDate/:endDate';
export const LOGGED_OUT_ONLINE_PAYMENTS = '/online-payment/:paymentRequestID';
export const LOGGED_OUT_SUCCESS = '/payment/status/:paymentRequestID';
export const ONLINE_PAYMENT_SUCCESS = '/payments/status';
export const ADHOC_PAYMENTS = '/payments/online-payment/:paymentRequestID';
export const ADHOC_PAYMENTS_SUCCESS =
  '/payments/payment-status/:paymentRequestID';
export const LOGGED_OUT_ORDER_EXPENSE_REQUEST_ACTION_ROUTE =
  '/order/expense-request/:expenseRequestPayload';
export const LOGGED_OUT_EXPENSE_REQUEST_ACTION_ROUTE =
  '/expense-request/:expenseRequestPayload';
export const GIFT_CARD_ROUTE = '/gift-card';
